export enum CodeScope {
  ARCHIVIO = 'ARCHIVIO',
  PEC = 'PEC',
  ANAGRAFE = 'ANAGRAFE',
  COMUNIC = 'COMUNIC',
}
